import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628c4137"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"align-self":"flex-start"} }, "Settings", -1))
const _hoisted_3 = {
  key: 0,
  class: "blink_me",
  style: {"margin-top":"100px"}
}
const _hoisted_4 = { style: {"display":"flex","flex-wrap":"wrap","margin-top":"4rem"} }

import store from '@/store';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const loading = ref(true)

const showSetDialog = (type: string) => {
    switch (type) {
        case "template":
            store.commit('SET_SHOW_SET_TEMPLATE_DIALOG', true)
            break;
        case "details":
            store.commit('SET_SHOW_SET_DETAILS_DIALOG', true)
            break;
        case "report":
            store.commit('SET_SHOW_SET_REPORT_DIALOG', true)
            break;
        case "chatbot":
            store.commit('SET_SHOW_SET_CHATBOT_DIALOG', true)
            break;
        default:
            break;
    }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : _createCommentVNode("", true),
    _createElementVNode("iframe", {
      width: "100%",
      height: "900px",
      onLoad: _cache[0] || (_cache[0] = ($event: any) => (loading.value = false)),
      style: _normalizeStyle([{ display: loading.value ? 'none' : 'block' }, {"border":"0"}]),
      src: "https://lookerstudio.google.com/embed/reporting/ce5e9d39-963a-482b-890c-d99a2696b057/page/hjqXD",
      frameborder: "0",
      allowfullscreen: ""
    }, null, 36),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "custom-button",
        style: {"margin":"0 .7rem"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showSetDialog('template')))
      }, "Prompt"),
      _createElementVNode("button", {
        class: "custom-button",
        style: {"margin":"0 .7rem"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showSetDialog('report')))
      }, "Report"),
      _createElementVNode("button", {
        class: "custom-button",
        style: {"margin":"0 .7rem"},
        onClick: _cache[3] || (_cache[3] = ($event: any) => (showSetDialog('details')))
      }, "Details"),
      _createElementVNode("button", {
        class: "custom-button",
        style: {"margin":"0 .7rem"},
        onClick: _cache[4] || (_cache[4] = ($event: any) => (showSetDialog('chatbot')))
      }, "Chatbot")
    ])
  ]))
}
}

})